/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'go': {
    width: 16,
    height: 16,
    viewBox: '0 0 82 82',
    data: '<path pid="0" d="M6 0C2.71 0 0 2.71 0 6v70c0 3.29 2.71 6 6 6h70c3.29 0 6-2.71 6-6V55a2 2 0 1 0-4 0v21c0 1.143-.857 2-2 2H6c-1.143 0-2-.857-2-2V6c0-1.143.857-2 2-2h70c1.143 0 2 .857 2 2v21a2 2 0 1 0 4 0V6c0-3.29-2.71-6-6-6H6zm37.844 18.969a2 2 0 0 0-1.344.687l-18 20a2 2 0 0 0 0 2.657l18 20a2.003 2.003 0 0 0 3-2.657L30.5 43H80a2 2 0 1 0 0-4H30.5l15-16.688a2 2 0 0 0-1.656-3.343z"/>'
  }
})
